import { defineMessages } from 'react-intl';

export default defineMessages({
    // addNotherVersionOfThisQuote: {
    //     id: 'custom.component.wal.WALAddNewVersionComponent.Add another version of this quote',
    //     defaultMessage: 'Add another version of this quote'
    // }
});
